"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1637],{

/***/ 5178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "calendar_svg__h-6 calendar_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCalendar);

/***/ }),

/***/ 5051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.707 5.293a1 1 0 0 1 0 1.414L9.414 10l3.293 3.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronLeft);

/***/ }),

/***/ 8453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "chevron-right_svg__h-5 chevron-right_svg__w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M7.293 14.707a1 1 0 0 1 0-1.414L10.586 10 7.293 6.707a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronRight);

/***/ }),

/***/ 8174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTable = function SvgTable(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "table_svg__h-6 table_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgTable);

/***/ }),

/***/ 1095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sJ": function() { return /* reexport */ PollDetailsForm; },
  "yt": function() { return /* reexport */ poll_options_form/* default */.Z; },
  "CO": function() { return /* reexport */ UserDetailsForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(692);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./src/utils/form-validation.ts
var form_validation = __webpack_require__(6001);
;// CONCATENATED MODULE: ./src/components/forms/poll-details-form.tsx






const PollDetailsForm = (param)=>{
    let { name , defaultValues , onSubmit , onChange , className  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("app");
    const { handleSubmit , register , watch , formState: { errors  }  } = (0,index_esm/* useForm */.cI)({
        defaultValues
    });
    react.useEffect(()=>{
        if (onChange) {
            const subscription = watch(onChange);
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        onChange,
        watch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        id: name,
        className: (0,clsx_m/* default */.Z)("max-w-full", className),
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "formField",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "title",
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        id: "title",
                        className: (0,clsx_m/* default */.Z)("input w-full", {
                            "input-error": errors.title
                        }),
                        placeholder: t("titlePlaceholder"),
                        ...register("title", {
                            validate: form_validation/* requiredString */.J
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "formField",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "location",
                        children: t("location")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        id: "location",
                        className: "input w-full",
                        placeholder: t("locationPlaceholder"),
                        ...register("location")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "description",
                        children: t("description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                        id: "description",
                        className: "input w-full",
                        placeholder: t("descriptionPlaceholder"),
                        rows: 5,
                        ...register("description")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/forms/poll-options-form/poll-options-form.tsx + 8 modules
var poll_options_form = __webpack_require__(1706);
;// CONCATENATED MODULE: ./src/components/forms/user-details-form.tsx






const UserDetailsForm = (param)=>{
    let { name , defaultValues , onSubmit , onChange , className  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("app");
    const { handleSubmit , register , watch , formState: { errors  }  } = (0,index_esm/* useForm */.cI)({
        defaultValues
    });
    react.useEffect(()=>{
        if (onChange) {
            const subscription = watch(onChange);
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        watch,
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        id: name,
        className: className,
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: t("yourDetails")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "formField",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "text-slate-500",
                        htmlFor: "name",
                        children: t("name")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        id: "name",
                        className: (0,clsx_m/* default */.Z)("input w-full", {
                            "input-error": errors.name
                        }),
                        placeholder: t("namePlaceholder"),
                        ...register("name", {
                            validate: form_validation/* requiredString */.J
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "formField",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "text-slate-500",
                        htmlFor: "contact",
                        children: t("email")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "contact",
                        className: (0,clsx_m/* default */.Z)("input w-full", {
                            "input-error": errors.contact
                        }),
                        placeholder: t("emailPlaceholder"),
                        ...register("contact", {
                            validate: form_validation/* validEmail */.u
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/forms/index.ts






/***/ }),

/***/ 1706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ poll_options_form; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(692);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./src/utils/date-time-utils.ts
var date_time_utils = __webpack_require__(5422);
// EXTERNAL MODULE: ./src/components/full-page-loader.tsx
var full_page_loader = __webpack_require__(13);
// EXTERNAL MODULE: ./src/components/icons/calendar.svg
var calendar = __webpack_require__(5178);
// EXTERNAL MODULE: ./src/components/icons/table.svg
var table = __webpack_require__(8174);
// EXTERNAL MODULE: ./src/components/modal/index.ts + 1 modules
var modal = __webpack_require__(1558);
// EXTERNAL MODULE: ./src/components/time-zone-picker/index.ts + 2 modules
var time_zone_picker = __webpack_require__(6310);
// EXTERNAL MODULE: ./src/utils/dayjs.tsx
var utils_dayjs = __webpack_require__(4752);
// EXTERNAL MODULE: ./src/components/button.tsx
var components_button = __webpack_require__(5295);
// EXTERNAL MODULE: ./src/components/compact-button.tsx
var compact_button = __webpack_require__(6683);
// EXTERNAL MODULE: ./src/components/date-card.tsx
var date_card = __webpack_require__(5664);
// EXTERNAL MODULE: ./src/components/dropdown.tsx + 1 modules
var dropdown = __webpack_require__(8875);
;// CONCATENATED MODULE: ./src/components/headless-date-picker.tsx


const today = new Date();
const useHeadlessDatePicker = (options)=>{
    const { dayjs  } = (0,utils_dayjs/* useDayjs */.a)();
    const [localSelection, setSelection] = react.useState([]);
    var _options_selection;
    const selection = (_options_selection = options === null || options === void 0 ? void 0 : options.selection) !== null && _options_selection !== void 0 ? _options_selection : localSelection;
    const [localNavigationDate, setNavigationDate] = react.useState(today);
    var _options_date;
    const navigationDate = dayjs((_options_date = options === null || options === void 0 ? void 0 : options.date) !== null && _options_date !== void 0 ? _options_date : localNavigationDate);
    const firstDayOfMonth = navigationDate.startOf("month");
    const firstDayOfFirstWeek = firstDayOfMonth.startOf("week");
    const currentMonth = navigationDate.get("month");
    const days = [];
    const daysOfWeek = [];
    for(let i = 0; i < 7; i++){
        daysOfWeek.push(firstDayOfFirstWeek.add(i, "days").format("dd"));
    }
    let reachedEnd = false;
    let i1 = 0;
    do {
        const d = firstDayOfFirstWeek.add(i1, "days");
        days.push({
            date: d.toDate(),
            day: d.format("D"),
            weekend: d.day() === 0 || d.day() === 6,
            outOfMonth: d.month() !== currentMonth,
            today: d.isSame(today, "day"),
            selected: selection.some((selectedDate)=>d.isSame(selectedDate, "day"))
        });
        i1++;
        reachedEnd = i1 > 34 && i1 % 7 === 0 && d.add(1, "day").month() !== currentMonth;
    }while (reachedEnd === false);
    var _options_selection1;
    return {
        navigationDate: navigationDate.toDate(),
        label: navigationDate.format("MMMM YYYY"),
        next: ()=>{
            var _options_onNavigationChange;
            const newDate = navigationDate.add(1, "month").startOf("month").toDate();
            if (!(options === null || options === void 0 ? void 0 : options.date)) {
                setNavigationDate(newDate);
            }
            options === null || options === void 0 ? void 0 : (_options_onNavigationChange = options.onNavigationChange) === null || _options_onNavigationChange === void 0 ? void 0 : _options_onNavigationChange.call(options, newDate);
        },
        prev: ()=>{
            var _options_onNavigationChange;
            const newDate = navigationDate.add(-1, "month").startOf("month").toDate();
            if (!(options === null || options === void 0 ? void 0 : options.date)) {
                setNavigationDate(newDate);
            }
            options === null || options === void 0 ? void 0 : (_options_onNavigationChange = options.onNavigationChange) === null || _options_onNavigationChange === void 0 ? void 0 : _options_onNavigationChange.call(options, newDate);
        },
        today: ()=>{
            var _options_onNavigationChange;
            const newDate = today;
            if (!(options === null || options === void 0 ? void 0 : options.date)) {
                setNavigationDate(newDate);
            }
            options === null || options === void 0 ? void 0 : (_options_onNavigationChange = options.onNavigationChange) === null || _options_onNavigationChange === void 0 ? void 0 : _options_onNavigationChange.call(options, newDate);
        },
        days,
        daysOfWeek,
        selection: (_options_selection1 = options === null || options === void 0 ? void 0 : options.selection) !== null && _options_selection1 !== void 0 ? _options_selection1 : selection,
        toggle: (date)=>{
            if (options === null || options === void 0 ? void 0 : options.selection) {
                // ignore, selection is controlled externally
                return;
            }
            const index = selection.indexOf(date);
            if (index === -1) {
                setSelection((s)=>[
                        ...s,
                        date
                    ]);
            } else {
                setSelection((s)=>s.splice(index, 1));
            }
        }
    };
};

// EXTERNAL MODULE: ./src/components/icons/chevron-left.svg
var chevron_left = __webpack_require__(5051);
// EXTERNAL MODULE: ./src/components/icons/chevron-right.svg
var chevron_right = __webpack_require__(8453);
// EXTERNAL MODULE: ./src/components/icons/dots-horizontal.svg
var dots_horizontal = __webpack_require__(1997);
;// CONCATENATED MODULE: ./src/components/icons/magic.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgMagic = function SvgMagic(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "magic_svg__h-6 magic_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16 2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
  })));
};

/* harmony default export */ var magic = (SvgMagic);
// EXTERNAL MODULE: ./src/components/icons/plus-sm.svg
var plus_sm = __webpack_require__(922);
// EXTERNAL MODULE: ./src/components/icons/trash.svg
var trash = __webpack_require__(8405);
// EXTERNAL MODULE: ./src/components/icons/x.svg
var x = __webpack_require__(3212);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(2351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(9946);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(1363);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(4103);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(6723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(3784);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(3781);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/label/label.js
let u=(0,react.createContext)(null);function c(){let o=(0,react.useContext)(u);if(o===null){let t=new Error("You used a <Label /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,c),t}return o}function M(){let[o,t]=(0,react.useState)([]);return[o.length>0?o.join(" "):void 0,(0,react.useMemo)(()=>function(e){let l=(0,use_event/* useEvent */.z)(a=>(t(i=>[...i,a]),()=>t(i=>{let n=i.slice(),d=n.indexOf(a);return d!==-1&&n.splice(d,1),n}))),r=(0,react.useMemo)(()=>({register:l,slot:e.slot,name:e.name,props:e.props}),[l,e.slot,e.name,e.props]);return react.createElement(u.Provider,{value:r},e.children)},[t])]}let h="label",F=(0,render/* forwardRefWithAs */.yV)(function(t,s){let{passive:e=!1,...l}=t,r=c(),a=`headlessui-label-${(0,use_id/* useId */.M)()}`,i=(0,use_sync_refs/* useSyncRefs */.T)(s);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>r.register(a),[a,r.register]);let n={ref:i,...r.props,id:a};return e&&("onClick"in n&&delete n.onClick,"onClick"in l&&delete l.onClick),(0,render/* render */.sY)({ourProps:n,theirProps:l,slot:r.slot||{},defaultTag:h,name:r.name||"Label"})});

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/description/description.js
var description = __webpack_require__(9516);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(4157);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(6045);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/form.js
var utils_form = __webpack_require__(8689);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/switch/switch.js
let p=(0,react.createContext)(null);p.displayName="GroupContext";let j=react.Fragment;function N(m){let[n,i]=(0,react.useState)(null),[r,s]=M(),[l,c]=(0,description/* useDescriptions */.f)(),d=(0,react.useMemo)(()=>({switch:n,setSwitch:i,labelledby:r,describedby:l}),[n,i,r,l]),u={},e=m;return react.createElement(c,{name:"Switch.Description"},react.createElement(s,{name:"Switch.Label",props:{onClick(){!n||(n.click(),n.focus({preventScroll:!0}))}}},react.createElement(p.Provider,{value:d},(0,render/* render */.sY)({ourProps:u,theirProps:e,defaultTag:j,name:"Switch.Group"}))))}let $="button",q=(0,render/* forwardRefWithAs */.yV)(function(n,i){let{checked:r,onChange:s,name:l,value:c,...d}=n,u=`headlessui-switch-${(0,use_id/* useId */.M)()}`,e=(0,react.useContext)(p),f=(0,react.useRef)(null),S=(0,use_sync_refs/* useSyncRefs */.T)(f,i,e===null?null:e.setSwitch),h=(0,use_event/* useEvent */.z)(()=>s(!r)),E=(0,use_event/* useEvent */.z)(t=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(t.currentTarget))return t.preventDefault();t.preventDefault(),h()}),w=(0,use_event/* useEvent */.z)(t=>{t.key===keyboard/* Keys.Space */.R.Space?(t.preventDefault(),h()):t.key===keyboard/* Keys.Enter */.R.Enter&&(0,utils_form/* attemptSubmit */.g)(t.currentTarget)}),P=(0,use_event/* useEvent */.z)(t=>t.preventDefault()),v=(0,react.useMemo)(()=>({checked:r}),[r]),g={id:u,ref:S,role:"switch",type:(0,use_resolve_button_type/* useResolveButtonType */.f)(n,f),tabIndex:0,"aria-checked":r,"aria-labelledby":e==null?void 0:e.labelledby,"aria-describedby":e==null?void 0:e.describedby,onClick:E,onKeyUp:w,onKeyPress:P};return react.createElement(react.Fragment,null,l!=null&&r&&react.createElement(internal_hidden/* Hidden */._,{features:internal_hidden/* Features.Hidden */.A.Hidden,...(0,render/* compact */.oA)({as:"input",type:"checkbox",hidden:!0,readOnly:!0,checked:r,name:l,value:c})}),(0,render/* render */.sY)({ourProps:g,theirProps:d,slot:v,defaultTag:$,name:"Switch"}))}),ue=Object.assign(q,{Group:N,Label:F,Description:description/* Description */.d});

;// CONCATENATED MODULE: ./src/components/switch.tsx




const Switch = (param)=>{
    let { checked =false , onChange , srDescription , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ue, {
        checked: checked,
        onChange: onChange,
        className: (0,clsx_m/* default */.Z)("relative inline-flex h-6 w-10 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75", {
            "bg-gray-200": !checked,
            "bg-green-500": checked
        }),
        ...rest,
        children: [
            srDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: srDescription
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "aria-hidden": "true",
                className: (0,clsx_m/* default */.Z)("pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out", {
                    "translate-x-4": checked,
                    "translate-x-0": !checked
                })
            })
        ]
    });
};
/* harmony default export */ var components_switch = (Switch);

// EXTERNAL MODULE: ./src/components/forms/poll-options-form/utils.ts
var utils = __webpack_require__(2693);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom-interactions/dist/floating-ui.react-dom-interactions.esm.js + 2 modules
var floating_ui_react_dom_interactions_esm = __webpack_require__(4287);
// EXTERNAL MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
var floating_ui_core_browser_min = __webpack_require__(8301);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js
var listbox = __webpack_require__(4729);
// EXTERNAL MODULE: ./src/utils/stop-propagation.ts
var stop_propagation = __webpack_require__(6708);
// EXTERNAL MODULE: ./src/components/icons/chevron-down.svg
var chevron_down = __webpack_require__(4312);
// EXTERNAL MODULE: ./src/components/menu-styles.ts
var menu_styles = __webpack_require__(9827);
;// CONCATENATED MODULE: ./src/components/forms/poll-options-form/month-calendar/time-picker.tsx









const TimePicker = (param)=>{
    let { value , onChange , className , startFrom  } = param;
    const { dayjs  } = (0,utils_dayjs/* useDayjs */.a)();
    const { reference , floating , x , y , strategy , refs  } = (0,floating_ui_react_dom_interactions_esm/* useFloating */.YF)({
        strategy: "fixed",
        middleware: [
            (0,floating_ui_core_browser_min/* offset */.cv)(5),
            (0,floating_ui_core_browser_min/* flip */.RR)(),
            (0,floating_ui_core_browser_min/* size */.dp)({
                apply: (param)=>{
                    let { rects  } = param;
                    if (refs.floating.current) {
                        Object.assign(refs.floating.current.style, {
                            width: "".concat(rects.reference.width, "px")
                        });
                    }
                }
            })
        ]
    });
    const renderOptions = ()=>{
        const startFromDate = startFrom ? dayjs(startFrom) : dayjs(value).startOf("day");
        const options = [];
        const startMinute = startFromDate.get("hour") * 60 + startFromDate.get("minute");
        const intervals = Math.floor((1440 - startMinute) / 15);
        for(let i = 0; i < intervals; i++){
            const optionValue = startFromDate.add(i * 15, "minutes");
            options.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                className: menu_styles/* styleMenuItem */.N,
                value: optionValue.format("YYYY-MM-DDTHH:mm:ss"),
                children: optionValue.format("LT")
            }, i));
        }
        return options;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
        value: dayjs(value).format("YYYY-MM-DDTHH:mm:ss"),
        onChange: (newValue)=>{
            onChange === null || onChange === void 0 ? void 0 : onChange(new Date(newValue));
        },
        children: (open)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: reference,
                        className: (0,clsx_m/* default */.Z)("relative", className),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                            className: "btn-default text-left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "grow truncate",
                                    children: dayjs(value).format("LT")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pointer-events-none ml-2 flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_down/* default */.Z, {
                                        className: "h-5 w-5"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floating_ui_react_dom_interactions_esm/* FloatingPortal */.ll, {
                        children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                            style: {
                                position: strategy,
                                left: x !== null && x !== void 0 ? x : "",
                                top: y !== null && y !== void 0 ? y : ""
                            },
                            ref: floating,
                            className: "z-50 max-h-52 overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                            onMouseDown: stop_propagation/* stopPropagation */.U,
                            children: renderOptions()
                        }) : null
                    })
                ]
            })
    });
};
/* harmony default export */ var time_picker = (TimePicker);

;// CONCATENATED MODULE: ./src/components/forms/poll-options-form/month-calendar/month-calendar.tsx






















const MonthCalendar = (param)=>{
    let { options , onNavigate , date , onChange , duration , onChangeDuration  } = param;
    const { dayjs , weekStartsOn  } = (0,utils_dayjs/* useDayjs */.a)();
    const { t  } = (0,esm/* useTranslation */.$G)("app");
    const isTimedEvent = options.some((option)=>option.type === "timeSlot");
    const optionsByDay = react.useMemo(()=>{
        const res = {};
        options.forEach((option, index)=>{
            const dateString = option.type === "date" ? option.date : option.start.substring(0, option.start.indexOf("T"));
            if (res[dateString]) {
                res[dateString].push({
                    option,
                    index
                });
            } else {
                res[dateString] = [
                    {
                        option,
                        index
                    }
                ];
            }
        });
        return res;
    }, [
        options
    ]);
    const datepickerSelection = react.useMemo(()=>{
        return Object.keys(optionsByDay).map((dateString)=>new Date(dateString + "T12:00:00"));
    }, [
        optionsByDay
    ]);
    const datepicker = useHeadlessDatePicker({
        selection: datepickerSelection,
        onNavigationChange: onNavigate,
        weekStartsOn,
        date
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden lg:flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-b p-3 sm:p-4 lg:w-[440px] lg:border-r lg:border-b-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-3 flex items-center justify-center space-x-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_left/* default */.Z, {}),
                                        title: t("previousMonth"),
                                        onClick: datepicker.prev
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grow text-center text-lg font-medium",
                                        children: datepicker.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                                        title: t("nextMonth"),
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {}),
                                        onClick: datepicker.next
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-7",
                                children: datepicker.daysOfWeek.map((dayOfWeek)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center justify-center pb-2 text-sm font-medium text-slate-400",
                                        children: dayOfWeek.substring(0, 2)
                                    }, dayOfWeek);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grow grid-cols-7 overflow-hidden rounded-lg border bg-white shadow-sm",
                                children: datepicker.days.map((day, i)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            if (datepicker.selection.some((selectedDate)=>dayjs(selectedDate).isSame(day.date, "day"))) {
                                                onChange((0,date_time_utils/* removeAllOptionsForDay */.eU)(options, day.date));
                                            } else {
                                                const selectedDate = dayjs(day.date).set("hour", 12).toDate();
                                                const newOption = !isTimedEvent ? {
                                                    type: "date",
                                                    date: (0,utils/* formatDateWithoutTime */.Y)(selectedDate)
                                                } : {
                                                    type: "timeSlot",
                                                    start: (0,utils/* formatDateWithoutTz */.S)(selectedDate),
                                                    end: (0,utils/* formatDateWithoutTz */.S)(dayjs(selectedDate).add(duration, "minutes").toDate())
                                                };
                                                onChange([
                                                    ...options,
                                                    newOption
                                                ]);
                                                onNavigate(selectedDate);
                                            }
                                            if (day.outOfMonth) {
                                                if (i < 6) {
                                                    datepicker.prev();
                                                } else {
                                                    datepicker.next();
                                                }
                                            }
                                        },
                                        className: (0,clsx_m/* default */.Z)("relative flex h-12 items-center justify-center text-sm hover:bg-slate-50 focus:ring-0 focus:ring-offset-0 active:bg-slate-100", {
                                            "bg-slate-50 text-slate-400": day.outOfMonth,
                                            "font-bold": day.today,
                                            "text-primary-500": day.today && !day.selected,
                                            "border-r": (i + 1) % 7 !== 0,
                                            "border-b": i < datepicker.days.length - 7,
                                            "font-normal text-white after:absolute after:-z-0 after:h-8 after:w-8 after:rounded-full after:bg-green-500 after:content-['']": day.selected
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "z-10",
                                            children: day.day
                                        })
                                    }, i);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                                className: "mt-3",
                                onClick: datepicker.today,
                                children: t("today")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex grow flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("border-b", {
                            hidden: datepicker.selection.length === 0
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center space-x-3 p-3 sm:p-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grow",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-medium",
                                            children: t("specifyTimes")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm text-slate-400",
                                            children: t("specifyTimesDescription")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_switch, {
                                        "data-testid": "specify-times-switch",
                                        checked: isTimedEvent,
                                        onChange: (checked)=>{
                                            if (checked) {
                                                // convert dates to time slots
                                                onChange(options.map((option)=>{
                                                    if (option.type === "timeSlot") {
                                                        throw new Error("Expected option to be a date but received timeSlot");
                                                    }
                                                    const startDate = new Date("".concat(option.date, "T12:00:00"));
                                                    const endDate = dayjs(startDate).add(duration, "minutes").toDate();
                                                    return {
                                                        type: "timeSlot",
                                                        start: (0,utils/* formatDateWithoutTz */.S)(startDate),
                                                        end: (0,utils/* formatDateWithoutTz */.S)(endDate)
                                                    };
                                                }));
                                            } else {
                                                onChange(datepicker.selection.map((date)=>({
                                                        type: "date",
                                                        date: (0,utils/* formatDateWithoutTime */.Y)(date)
                                                    })));
                                            }
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow",
                        children: isTimedEvent ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "divide-y",
                            children: Object.keys(optionsByDay).sort((a, b)=>a > b ? 1 : -1).map((dateString)=>{
                                const optionsForDay = optionsByDay[dateString];
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-3 p-3 sm:flex sm:space-y-0 sm:space-x-4 sm:p-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(date_card/* default */.Z, {
                                                ...(0,date_time_utils/* getDateProps */.ZP)(new Date(dateString + "T12:00:00"))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grow space-y-3",
                                            children: [
                                                optionsForDay.map((param)=>{
                                                    let { option , index  } = param;
                                                    if (option.type === "date") {
                                                        throw new Error("Expected timeSlot but got date");
                                                    }
                                                    const startDate = new Date(option.start);
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(time_picker, {
                                                                value: startDate,
                                                                onChange: (newStart)=>{
                                                                    let newEnd = dayjs(newStart).add(duration, "minutes");
                                                                    if (!newEnd.isSame(newStart, "day")) {
                                                                        newEnd = newEnd.set("hour", 23).set("minute", 45);
                                                                    }
                                                                    // replace enter with updated start time
                                                                    onChange([
                                                                        ...options.slice(0, index),
                                                                        {
                                                                            ...option,
                                                                            start: (0,utils/* formatDateWithoutTz */.S)(newStart),
                                                                            end: (0,utils/* formatDateWithoutTz */.S)(newEnd.toDate())
                                                                        },
                                                                        ...options.slice(index + 1)
                                                                    ]);
                                                                    onNavigate(newStart);
                                                                    onChangeDuration(newEnd.diff(newStart, "minutes"));
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(time_picker, {
                                                                value: new Date(option.end),
                                                                startFrom: dayjs(startDate).add(15, "minutes").toDate(),
                                                                onChange: (newEnd)=>{
                                                                    onChange([
                                                                        ...options.slice(0, index),
                                                                        {
                                                                            ...option,
                                                                            end: (0,utils/* formatDateWithoutTz */.S)(newEnd)
                                                                        },
                                                                        ...options.slice(index + 1)
                                                                    ]);
                                                                    onNavigate(newEnd);
                                                                    onChangeDuration(dayjs(newEnd).diff(startDate, "minutes"));
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(compact_button/* default */.Z, {
                                                                icon: x/* default */.Z,
                                                                onClick: ()=>{
                                                                    onChange([
                                                                        ...options.slice(0, index),
                                                                        ...options.slice(index + 1)
                                                                    ]);
                                                                }
                                                            })
                                                        ]
                                                    }, index);
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(plus_sm/* default */.Z, {}),
                                                            onClick: ()=>{
                                                                const lastOption = (0,date_time_utils/* expectTimeOption */.C)(optionsForDay[optionsForDay.length - 1].option);
                                                                const startTime = lastOption.start;
                                                                onChange([
                                                                    ...options,
                                                                    {
                                                                        type: "timeSlot",
                                                                        start: startTime,
                                                                        end: (0,utils/* formatDateWithoutTz */.S)(dayjs(new Date(startTime)).add(duration, "minutes").toDate())
                                                                    }
                                                                ]);
                                                            },
                                                            children: t("addTimeOption")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown/* default */.Z, {
                                                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(compact_button/* default */.Z, {
                                                                icon: dots_horizontal/* default */.Z
                                                            }),
                                                            placement: "bottom-start",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                                                                    icon: magic,
                                                                    disabled: datepicker.selection.length < 2,
                                                                    label: t("applyToAllDates"),
                                                                    onClick: ()=>{
                                                                        const times = optionsForDay.map((param)=>{
                                                                            let { option  } = param;
                                                                            if (option.type === "date") {
                                                                                throw new Error("Expected timeSlot but got date");
                                                                            }
                                                                            return {
                                                                                startTime: option.start.substring(option.start.indexOf("T")),
                                                                                endTime: option.end.substring(option.end.indexOf("T"))
                                                                            };
                                                                        });
                                                                        const newOptions = [];
                                                                        Object.keys(optionsByDay).forEach((dateString)=>{
                                                                            times.forEach((time)=>{
                                                                                newOptions.push({
                                                                                    type: "timeSlot",
                                                                                    start: dateString + time.startTime,
                                                                                    end: dateString + time.endTime
                                                                                });
                                                                            });
                                                                        });
                                                                        onChange(newOptions);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                                                                    label: t("deleteDate"),
                                                                    icon: trash/* default */.Z,
                                                                    onClick: ()=>{
                                                                        onChange((0,date_time_utils/* removeAllOptionsForDay */.eU)(options, new Date(dateString)));
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, dateString);
                            })
                        }) : datepicker.selection.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-[repeat(auto-fill,54px)] gap-3 p-3 sm:gap-4 sm:p-4",
                            children: datepicker.selection.sort((a, b)=>a.getTime() - b.getTime()).map((selectedDate, i)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(date_card/* default */.Z, {
                                    ...(0,date_time_utils/* getDateProps */.ZP)(selectedDate),
                                    annotation: /*#__PURE__*/ (0,jsx_runtime.jsx)(compact_button/* default */.Z, {
                                        icon: x/* default */.Z,
                                        onClick: ()=>{
                                            // TODO (Luke Vella) [2022-03-19]: Find cleaner way to manage this state
                                            // Quite tedious right now to remove a single element
                                            onChange((0,date_time_utils/* removeAllOptionsForDay */.eU)(options, selectedDate));
                                        }
                                    })
                                }, i);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-full items-center justify-center py-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center font-medium text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar/* default */.Z, {
                                        className: "mb-2 inline-block h-12 w-12"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: t("noDatesSelected")
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var month_calendar = (MonthCalendar);

;// CONCATENATED MODULE: ./src/components/forms/poll-options-form/month-calendar/index.ts


;// CONCATENATED MODULE: ./src/components/forms/poll-options-form/poll-options-form.tsx












const WeekCalendar = /*#__PURE__*/ react.lazy(()=>Promise.all(/* import() */[__webpack_require__.e(2770), __webpack_require__.e(4225), __webpack_require__.e(4623)]).then(__webpack_require__.bind(__webpack_require__, 4623)));
const PollOptionsForm = (param)=>{
    let { name , defaultValues , onSubmit , onChange , title , className  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("app");
    const { control , handleSubmit , watch , setValue , formState  } = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            options: [],
            duration: 30,
            timeZone: "",
            navigationDate: new Date().toISOString(),
            ...defaultValues
        },
        resolver: (values)=>{
            return {
                values,
                errors: values.options.length === 0 ? {
                    options: true
                } : {}
            };
        }
    });
    const views = react.useMemo(()=>{
        const res = [
            {
                label: t("monthView"),
                value: "month",
                Component: month_calendar
            },
            {
                label: t("weekView"),
                value: "week",
                Component: WeekCalendar
            }
        ];
        return res;
    }, [
        t
    ]);
    const watchView = watch("view");
    var _views_find;
    const selectedView = react.useMemo(()=>(_views_find = views.find((view)=>view.value === watchView)) !== null && _views_find !== void 0 ? _views_find : views[0], [
        views,
        watchView
    ]);
    const watchOptions = watch("options");
    const watchDuration = watch("duration");
    const watchTimeZone = watch("timeZone");
    const datesOnly = watchOptions.every((option)=>option.type === "date");
    const [dateOrTimeRangeModal, openDateOrTimeRangeModal] = (0,modal/* useModal */.d)({
        title: t("mixedOptionsTitle"),
        description: t("mixedOptionsDescription"),
        okText: t("mixedOptionsKeepTimes"),
        onOk: ()=>{
            setValue("options", watchOptions.filter((option)=>option.type === "timeSlot"));
            if (!watchTimeZone) {
                setValue("timeZone", (0,date_time_utils/* getBrowserTimeZone */.ei)());
            }
        },
        cancelText: t("mixedOptionsKeepDates"),
        onCancel: ()=>{
            setValue("options", watchOptions.filter((option)=>option.type === "date"));
            setValue("timeZone", "");
        }
    });
    react.useEffect(()=>{
        if (onChange) {
            const subscription = watch((param)=>{
                let { options =[] , ...rest } = param;
                // Watch returns a deep partial here which is not really accurate and messes up
                // the types a bit. Repackaging it to keep the types sane.
                onChange({
                    options: options,
                    ...rest
                });
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        watch,
        onChange
    ]);
    react.useEffect(()=>{
        if (watchOptions.length > 1) {
            const optionType = watchOptions[0].type;
            // all options needs to be the same type
            if (watchOptions.some((option)=>option.type !== optionType)) {
                openDateOrTimeRangeModal();
            }
        }
    }, [
        watchOptions,
        openDateOrTimeRangeModal
    ]);
    const watchNavigationDate = watch("navigationDate");
    const navigationDate = new Date(watchNavigationDate);
    const [calendarHelpModal, openHelpModal] = (0,modal/* useModal */.d)({
        overlayClosable: true,
        title: t("calendarHelpTitle"),
        description: t("calendarHelp"),
        okText: t("ok")
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        id: name,
        className: (0,clsx_m/* default */.Z)("max-w-full", className),
        style: {
            width: 1024
        },
        onSubmit: handleSubmit(onSubmit, openHelpModal),
        children: [
            calendarHelpModal,
            dateOrTimeRangeModal,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full items-center space-y-2 border-b py-3 px-4 lg:flex lg:space-y-0 lg:space-x-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            control: control,
                            name: "timeZone",
                            render: (param)=>/*#__PURE__*/ {
                                let { field  } = param;
                                return (0,jsx_runtime.jsx)(time_zone_picker/* default */.Z, {
                                    value: field.value,
                                    onBlur: field.onBlur,
                                    onChange: (timeZone)=>{
                                        setValue("timeZone", timeZone, {
                                            shouldTouch: true
                                        });
                                    },
                                    disabled: datesOnly
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex space-x-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "segment-button w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: (0,clsx_m/* default */.Z)({
                                        "segment-button-active": selectedView.value === "month"
                                    }),
                                    onClick: ()=>{
                                        setValue("view", "month");
                                    },
                                    type: "button",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar/* default */.Z, {
                                            className: "mr-2 h-5 w-5"
                                        }),
                                        " ",
                                        t("monthView")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: (0,clsx_m/* default */.Z)({
                                        "segment-button-active": selectedView.value === "week"
                                    }),
                                    type: "button",
                                    onClick: ()=>{
                                        setValue("view", "week");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
                                            className: "mr-2 h-5 w-5"
                                        }),
                                        " ",
                                        t("weekView")
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_page_loader/* default */.Z, {
                        className: "h-[400px]",
                        children: t("loading")
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(selectedView.Component, {
                        title: title,
                        options: watchOptions,
                        date: navigationDate,
                        onNavigate: (date)=>{
                            setValue("navigationDate", date.toISOString());
                        },
                        onChange: (options)=>{
                            setValue("options", options);
                            if (options.length === 0 || options.every((option)=>option.type === "date")) {
                                // unset the timeZone if we only have date option
                                setValue("timeZone", "");
                            }
                            if (options.length > 0 && !formState.touchedFields.timeZone && options.every((option)=>option.type === "timeSlot")) {
                                // set timeZone if we are adding time ranges and we haven't touched the timeZone field
                                setValue("timeZone", (0,date_time_utils/* getBrowserTimeZone */.ei)());
                            }
                        },
                        duration: watchDuration,
                        onChangeDuration: (duration)=>{
                            setValue("duration", duration);
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var poll_options_form = (/*#__PURE__*/react.memo(PollOptionsForm));


/***/ }),

/***/ 2693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ formatDateWithoutTz; },
/* harmony export */   "Y": function() { return /* binding */ formatDateWithoutTime; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

const formatDateWithoutTz = (date)=>{
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("YYYY-MM-DDTHH:mm:ss");
};
const formatDateWithoutTime = (date)=>{
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("YYYY-MM-DD");
};


/***/ }),

/***/ 5155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4752);
/* harmony import */ var _standard_layout_mobile_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4831);




const StandardLayout = (param)=>{
    let { children , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_dayjs__WEBPACK_IMPORTED_MODULE_2__/* .DayjsProvider */ .L, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-pattern relative min-h-full",
            ...rest,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_standard_layout_mobile_navigation__WEBPACK_IMPORTED_MODULE_3__/* .MobileNavigation */ .$, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mx-auto max-w-4xl",
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StandardLayout);


/***/ }),

/***/ 1558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ useModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/modal/modal.tsx + 11 modules
var modal_modal = __webpack_require__(5395);
;// CONCATENATED MODULE: ./src/components/modal/use-modal.tsx



const useModal = (props)=>{
    const [visible, setVisible] = react.useState(false);
    const modal = /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_modal/* default */.Z, {
        ...props,
        visible: visible,
        onOk: ()=>{
            var _props_onOk;
            props === null || props === void 0 ? void 0 : (_props_onOk = props.onOk) === null || _props_onOk === void 0 ? void 0 : _props_onOk.call(props);
            setVisible(false);
        },
        onCancel: ()=>{
            var _props_onCancel;
            props === null || props === void 0 ? void 0 : (_props_onCancel = props.onCancel) === null || _props_onCancel === void 0 ? void 0 : _props_onCancel.call(props);
            setVisible(false);
        }
    });
    return [
        modal,
        ()=>setVisible(true),
        ()=>setVisible(false)
    ];
};

;// CONCATENATED MODULE: ./src/components/modal/index.ts



/***/ })

}]);